import React from 'react';
import { Radio } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
const EngineShopVisit = ({ mode, maintenaceObj, onChangeEvents }) => {
  return (
    <div className="engine-sv-table">
      <div>
        <label>Shop Visit Details - Last Performed Event</label>
        <table cellSpacing={0} cellPadding={0}>
          <thead>
            <tr>
              <th></th>
              {Array(maintenaceObj.engine_sv_details.no_of_engines).fill(1).map((engine, index) =>
                <th>Engine #{index + 1}</th>
              )}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td align="left">No Event Performed</td>
              {Array(maintenaceObj.engine_sv_details.no_of_engines).fill(1).map((engine, index) =>
                <td align="center">
                  {mode === 'view' ?
                    maintenaceObj.engine_sv_details && maintenaceObj.engine_sv_details.engines && maintenaceObj.engine_sv_details.engines[index].last_performed_sv === null ? <CheckIcon style={{ color: '#02a402' }} fontSize="small" /> : '--'
                    :
                    <Radio checked={maintenaceObj.engine_sv_details && maintenaceObj.engine_sv_details.engines && maintenaceObj.engine_sv_details.engines[index].last_performed_sv === null ? true : false} onClick={(e) => onChangeEvents(e, 'last_performed_sv', null, index)} size="small" color="primary" />
                  }
                </td>
              )}
            </tr>
            {maintenaceObj.engine_sv_details && maintenaceObj.engine_sv_details.engines && maintenaceObj.engine_sv_details.engines[0].engine_prsv.map((shopVisit, index) =>
              <tr key={index}>
                <td align="left">{shopVisit.event}</td>
                {Array(maintenaceObj.engine_sv_details.no_of_engines).fill(1).map((engine, engineIndex) => {
                  return (
                    <td align="center">
                      {mode === 'view' ?
                        maintenaceObj.engine_sv_details.engines[engineIndex].last_performed_sv === shopVisit.id ? <CheckIcon style={{ color: '#02a402' }} fontSize="small" /> : '--' :
                        <Radio disabled={engineIndex + 1 > maintenaceObj.engine_sv_details.no_of_engines ? true : false} checked={maintenaceObj.engine_sv_details.engines[engineIndex].last_performed_sv === shopVisit.id ? true : false} onClick={(e) => onChangeEvents(e, 'last_performed_sv', shopVisit.id, engineIndex)} size="small" color="primary" />
                      }
                    </td>
                  )
                }

                )}
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {maintenaceObj.engine_sv_details.engines && maintenaceObj.engine_sv_details.engines.length && maintenaceObj.engine_sv_details.engines[0].engine_hsi ?
        <div style={{ marginTop: '15px' }}>
          <label>Shop Visit Details - Last Performed HSI</label>
          <table border={1} cellSpacing={0} cellPadding={0}>
            <thead>
              <tr>
                <th></th>
                {Array(maintenaceObj.aircraft_type.no_of_engines).fill(1).map((engine, index) =>
                  <th>Engine #{index + 1}</th>
                )}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td align="left">No Event Performed</td>
                {Array(maintenaceObj.aircraft_type.no_of_engines).fill(1).map((engine, index) =>
                  <td align="center">
                    {mode === 'view' ?
                      maintenaceObj.engine_sv_details && maintenaceObj.engine_sv_details.engines && maintenaceObj.engine_sv_details.engines[index].last_performed_hsi === null ? <CheckIcon style={{ color: '#02a402' }} fontSize="small" /> : '--'
                      :
                      <Radio checked={maintenaceObj.engine_sv_details && maintenaceObj.engine_sv_details.engines && maintenaceObj.engine_sv_details.engines[index].last_performed_hsi === null ? true : false} onClick={(e) => onChangeEvents(e, 'last_performed_hsi', null, index)} size="small" color="primary" />
                    }
                  </td>
                )}
              </tr>
              {maintenaceObj.engine_sv_details && maintenaceObj.engine_sv_details.engines && maintenaceObj.engine_sv_details.engines[0].engine_hsi.map((shopVisit, index) =>
                <tr key={index}>
                  <td align="left">{shopVisit.event}</td>
                  {Array(maintenaceObj.aircraft_type.no_of_engines).fill(1).map((engine, engineIndex) =>
                    <td align="center">
                      {mode === 'view' ?
                        maintenaceObj.engine_sv_details.engines[engineIndex].last_performed_hsi === shopVisit.id ? <CheckIcon style={{ color: '#02a402' }} fontSize="small" /> : '--' :
                        <Radio checked={maintenaceObj.engine_sv_details.engines[engineIndex].last_performed_hsi === shopVisit.id ? true : false} onClick={(e) => onChangeEvents(e, 'last_performed_hsi', shopVisit.id, engineIndex)} size="small" color="primary" />
                      }
                    </td>
                  )}
                </tr>
              )}
            </tbody>
          </table>
        </div> : null
      }
    </div>
  )
}
export default EngineShopVisit;
